import { LBButton } from '@linearb/buzz';
import Divider from '@material-ui/core/Divider';
import { Flex } from 'components/base/layout-components';
import * as TrackingService from 'common/services/tracking.service';
import Text from 'components/base/Text';
import { logOut } from 'common/services/auth.service';
import { TRACKING } from 'common/constants/constants';

const reload = () => {
  TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
    page_tab: TRACKING.PAGE_TABS.EXPIRED,
    click_type: TRACKING.CLICK.RELOAD
  });
  logOut();
};

const SessionExpiredModal = () => {
  return (
    <Flex direction='column'>
      <Text size='x-x-x-large' pt='1.2rem' pb='1.2rem' pl='2rem' weight='400'>
        Session Expired
      </Text>
      <Divider />
      <Text size='x-x-large' pt='2rem' pl='2rem' weight='400'>
        Your session has expired.
      </Text>
      <Text size='x-x-large' pt='0.5rem' pl='2rem' weight='400'>
        You will be redirected to the login page.
      </Text>
      <Flex
        width='100%'
        justify='center'
        align='center'
        content='center'
        pt='medium'
        pb='medium'
      >
        <LBButton size='lg' onClick={reload}>
          OK
        </LBButton>
      </Flex>
    </Flex>
  );
};

export default SessionExpiredModal;
